import { Tab, Tabs } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import Box from "../../Box";
import Button from "../../Button";
import Helpers from "../../../commons/helpers";
import useStrings from "../../../hooks/useStrings";
import AddNewUserTab from "../Tab/addNewUserTab";
import AddManageUserTab from "../Tab/addManageUserTab";
import UserService from "../../../services/identity/user.service";
import InvitationService from "../../../services/identity/invitation.service";

import { IManageUser } from "../../../commons/interfaces";
import { useCommonComponentContext } from "../../../providers/CommonComponentProvider";

interface IProps {
    addOrganizationIds: string[];
    onClose: () => void;
}

const AddUserStep: React.FC<IProps> = ({ onClose, addOrganizationIds }: IProps) => {
    const strings = useStrings();
    const { onError, onHideLoading, onShowLoading, clientId } = useCommonComponentContext();

    const [value, setValue] = useState(0);
    const [userData, setUserData] = useState<IManageUser[]>([]);
    const [selectedData, setSelectedData] = useState<IManageUser[]>([]);
    const [selectedNewData, setSelectedNewData] = useState<IManageUser[]>([]);
    const [newData, setNewData] = useState<IManageUser[]>([]);

    useEffect(() => {
        const getData = async () => {
            const result = await UserService.getManageUser();
            setUserData(result);
        };
        getData();
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const renderTabContent = useCallback(() => {
        if (value === 0) return <AddManageUserTab data={userData} onSelected={setSelectedData} selectedData={selectedData} />;
        return <AddNewUserTab onSelected={setSelectedNewData} onAddNewData={setNewData} data={newData} selectedData={selectedNewData} />;
    }, [value, selectedData, selectedNewData, newData, setSelectedData, setSelectedNewData, userData]);

    const onAction = async () => {
        try {
            onShowLoading();
            let emails: string[] = [];
            selectedData.map((item) => {
                if (!emails.includes(item.email)) emails.push(item.email);
            });
            selectedNewData.map((item) => {
                if (!emails.includes(item.email)) emails.push(item.email);
            });
            let data = {
                clientId: clientId,
                organizationIds: addOrganizationIds,
                emails,
            };
            await InvitationService.quickInvite(data);
            onClose();
        } catch (error: any) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    return (
        <>
            <Box sx={{ height: 404, overflowY: "scroll" }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label={strings.Common.UNDER_MANAGEMENT} {...a11yProps(0)} />
                    <Tab label={strings.Common.ADD_NEW} {...a11yProps(1)} />
                </Tabs>
                {renderTabContent()}
            </Box>
            <Box display="flex" justifyContent="flex-end" alignItems="flex-end" my={0.5}>
                <Button color="secondary" style={{ marginRight: 5 }} onClick={onClose}>
                    {strings.Common.SKIP}
                </Button>

                <Button onClick={onAction}>{strings.Common.COMPLETE}</Button>
            </Box>
        </>
    );
};

const a11yProps = (index: number) => {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
};

export default AddUserStep;
